import { AppProps } from 'next/app';
import Head from 'next/head';
import './styles.css';
import { Layout } from '../layouts/basic';
import { IndexProps } from './index';
import { I18nextProvider } from 'react-i18next';
import { initI18n, getAppI18nConfig } from 'cfgi18n';
import i18next from 'i18next';
import { useEffect, useState } from 'react';

function CustomApp({ Component, pageProps }: AppProps<IndexProps & {locale: string}>) {
    const [ready, setReady] = useState<boolean>(false);

	useEffect(() => {
		const setup = async () => {
			const { supportedLocales } = await getAppI18nConfig('players');
			const i18n = await initI18n(pageProps.locale, supportedLocales);
			i18n.options.nsSeparator = false;
			setReady(true);
		}

		setup();

	}, []);

	if (!ready) return null;
    return (
        <>
            <Head>
                <title>Manchester City Squad Players</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <meta
                    name="description"
                    content="Man City Men's, Women's, EDS, Academy squad players and Esports team members. Get the latest news, videos and social media for all the City roster. "
                />
            </Head>

            <main className="app">
                <I18nextProvider i18n={i18next}>
                    <Layout
                        footerData={pageProps.footerData}
                        mainNavData={pageProps.mainNavData}
                        partnersData={pageProps.partnersData}
                    >
                        <Component {...pageProps} />
                    </Layout>
                </I18nextProvider>
            </main>
        </>
    );
}

export default CustomApp;
